<template>
  <div class="game-head">
    <div class="main">
      <div class="one info">
        <div class="flex-box">
          <router-link :to="{ name: 'FCEditGame', params: {'key':  preview.contest.key,'gameKey': preview.game.key}}"><h3 class="title">{{preview.game.name}}</h3></router-link>
          <button class="change-btn show" v-if="preview.game.is_closed" :disabled="preview.game.is_finalized" @click="publishLeaderboard">Publish Leaderboard</button>
        </div>
        <p class="detail-text">{{preview.game.desc}}</p>
        <div class="game-info" v-if="!preview.game.is_closed">
          <div class="closetime">
            <span>Game participation close at</span>&nbsp;
            <b>{{preview.game.closesAt | relativeShortDateTime}}</b>
          </div>
        </div>
        <div class="links">
          <button :class="showPreview == 'rule' ? 'active' : ''"
            class="clean small link"
            @click="showPreview='rule'">Rule</button>
          <button :class="showPreview == 'rewards' ? 'active' : ''"
            class="clean small link"
            @click="showPreview='rewards'">Rewards</button>
        </div>
      </div>
      <div class="two">
        <div class="sport-icon">
            <img v-if="preview.contest.sport.isCricket" src="@/assets/imgs/batsman-ready.png" />
            <img v-else-if="preview.contest.sport.isFootball" src="@/assets/imgs/sport-football.svg" />
        </div>
      </div>
    </div>
    <div v-if="showPreview" class="previews card inv">
      <transition name="fade">
        <RulePreview v-if="showPreview === 'rule'" :ruleKey="preview.contest.rule_key"></RulePreview>
      </transition>
      <transition name="fade">
        <RewardPreview
          v-if="showPreview === 'rewards'"
          :rewardKey="preview.contest.rewards_key"></RewardPreview>
      </transition>
    </div>
  </div>
</template>
<script>
import RulePreview from '@/components/fantasyconsole/RulePreview'
import RewardPreview from '@/components/fantasyconsole/RewardPreview'
import PointsystemPreview from '@/components/fantasygame/PointsystemPreview'

export default {
  components: {
    RulePreview,
    RewardPreview,
    PointsystemPreview
  },

  props: {
    preview: Object
  },

  data () {
    return {
      showPreview: 'rule'
    }
  },
  methods : {
    publishLeaderboard () {
      this.$emit('publishLeaderboard')
    }
  }
}
</script>
